if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            // Remove the cart page redirection and always use cart drawer
            // This is the key fix - removed the window.location redirect

            const startMarker = CartPerformance?.createStartingMarker
              ? CartPerformance.createStartingMarker('add:wait-for-subscribers')
              : null;
            if (!this.error && typeof publish === 'function')
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                if (startMarker && CartPerformance?.measureFromMarker) {
                  CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                }
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (CartPerformance?.measure) {
                      CartPerformance.measure('add:paint-updated-sections', () => {
                        this.cart.renderContents(response);
                      });
                    } else {
                      this.cart.renderContents(response);
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // If no cart exists, we need to update the cart drawer manually
              if (!this.cart) {
                // Check if we need to fetch and render the cart drawer
                this.updateAndOpenCartDrawer(response);
                return;
              }

              if (CartPerformance?.measure) {
                CartPerformance.measure('add:paint-updated-sections', () => {
                  this.cart.renderContents(response);
                });
              } else {
                this.cart.renderContents(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            if (CartPerformance?.measureFromEvent) {
              CartPerformance.measureFromEvent('add:user-action', evt);
            }
          });
      }

      updateAndOpenCartDrawer(response) {
        // If there's no cart component but we have a cart drawer element, update it manually
        const cartDrawer = document.getElementById('cart-drawer');
        if (!cartDrawer) return;

        // Fetch and update the cart drawer
        fetch('/?sections=cart-drawer')
          .then((response) => response.json())
          .then((sections) => {
            if (sections['cart-drawer']) {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = sections['cart-drawer'];

              // Get the new drawer content
              const newDrawer = tempDiv.querySelector('#cart-drawer');
              if (newDrawer) {
                // Replace the entire drawer or just its contents
                if (cartDrawer.parentNode) {
                  cartDrawer.innerHTML = newDrawer.innerHTML;
                }

                // Make sure the drawer overlay exists
                let overlay = document.querySelector('.cart-drawer-overlay');
                if (!overlay) {
                  overlay = document.createElement('div');
                  overlay.classList.add('cart-drawer-overlay');
                  document.body.appendChild(overlay);

                  // Add click event to close the drawer
                  overlay.addEventListener('click', () => {
                    cartDrawer.classList.remove('active');
                    overlay.classList.remove('active');
                    document.body.style.overflow = '';
                  });
                }

                // Add close button functionality
                const closeBtn = cartDrawer.querySelector('.cart-drawer__close');
                if (closeBtn) {
                  closeBtn.addEventListener('click', () => {
                    cartDrawer.classList.remove('active');
                    overlay.classList.remove('active');
                    document.body.style.overflow = '';
                  });
                }

                // Initialize the cart drawer functionality
                if (window.CartDrawer) {
                  // If we already have an instance, update it
                  if (window.cartDrawerInstance) {
                    // Reassign drawer and overlay to ensure they're correct
                    window.cartDrawerInstance.drawer = cartDrawer;
                    window.cartDrawerInstance.overlay = overlay;
                    // Rebind events
                    window.cartDrawerInstance.bindEvents();
                    // Update cart count in header - This is the key fix for issue #1
                    window.cartDrawerInstance.updateCartCount();
                  } else {
                    // Create a new instance if one doesn't exist
                    window.cartDrawerInstance = new window.CartDrawer();
                  }
                }

                // Open the drawer
                cartDrawer.classList.add('active');
                overlay.classList.add('active');
                document.body.style.overflow = 'hidden';
              }
            }
          })
          .catch((error) => {
            console.error('Error updating cart drawer:', error);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
